module.exports = __webpack_public_path__ + "static/turquia-011.thumb-e50f5962b484fdb028cbaf1a445f8243.jpg";